<template>
  <div>
    <div class="card">
      <div class="card-header">
        <ul class="nav nav-tabs justify-content-left">
            <li class="nav-item">
              <a class="nav-link active" data-toggle="tab" :href="`#data${document.id}`">{{title}}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" :href="`#scans${document.id}`">{{scansTitle}}</a>
            </li>
            <span class="tab-bar"></span>
         </ul>
      </div>
      <div>
        <div class="card-body">
          <div class="tab-content">
            <div class="tab-pane fade show active" :id="`data${document.id}`" :ref="`data${document.id}`">
              <component :is="viewComponent" :id="document.id" :documentData="document.data" />
              <button
                class="btn btn-link collapsed float-right"
                @click="$emit('actionDelte', document.id)"
              >Удалить</button>
              <button
                class="btn btn-link collapsed float-right"
                @click="$emit('actionUpdate', document.id)"
              >Изменить</button>
            </div>
            <div class="tab-pane fade loader" :id="`scans${document.id}`">
              <Scans :documentId="document.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Document',
  props: ['viewComponent', 'document', 'title', 'scansTitle']
}
</script>

<style scoped>
  .card {
    width: 100%;
    margin-top: 1rem;
  }
  .tab-pane {
    padding: 20px;
    position: relative;
  }
  .card-header .btn-link {
    color: #0597f2;
  }
  .card-header {
    background-color: white !important;
  }
  .nav-tabs {
    border: none;
  }
  .nav-item .nav-link {
    border: none;
    color: #212529;
  }
  .nav-item .nav-link.active {
    color: #0597f2;
    border-bottom: 2px solid #0597f2;
  }
  .card-header {
    padding-bottom: 0;
  }

</style>
